var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.755859 9.9999C0.755859 4.4775 5.23336 0 10.7558 0C16.2782 0 20.7557 4.4775 20.7557 9.9999C20.7557 15.5232 16.2782 19.9998 10.7558 19.9998C5.23336 19.9998 0.755859 15.5232 0.755859 9.9999ZM1.54786 9.9999C1.54786 15.0777 5.67886 19.2078 10.7558 19.2078C15.8327 19.2078 19.9637 15.0777 19.9637 9.9999C19.9637 4.923 15.8327 0.792 10.7558 0.792C5.67886 0.792 1.54786 4.923 1.54786 9.9999ZM10.2995 14.3181L7.44466 11.5749C7.19266 11.3328 7.19266 10.9395 7.44466 10.6974C7.69666 10.4553 8.10616 10.4553 8.35816 10.6974L10.1096 12.3813V6.1209C10.1096 5.778 10.3994 5.4999 10.7558 5.4999C11.1122 5.4999 11.402 5.778 11.402 6.1209V12.3813L13.1534 10.6974C13.4054 10.4553 13.8149 10.4553 14.0669 10.6974C14.3189 10.9395 14.3189 11.3328 14.0669 11.5749L11.2121 14.3181C11.087 14.4396 10.9214 14.4999 10.7558 14.4999C10.5902 14.4999 10.4255 14.4396 10.2995 14.3181Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDownIcon);
export default __webpack_public_path__ + "static/media/moveDownIcon.fe3425abfe3657104f7560983a2e4413.svg";
export { ForwardRef as ReactComponent };